export const planFeatures = {
  free: [
    "Create appointments and meetings without dates and times that calendar themselves.",
    "Uniquely create auto-cohorting multi-meetings that coordinate and calendar themselves repeatedly for many participants.",
    "Outside invitees can use your link to pick a time with you.",
    "Users can use calendar intelligence to coordinate the best time for you and your invitees.",
    "Personal Profile page.",
    "Social posting.",
    "Create social and extra-credit Cred.",
    "Create regular events for fellow users.",
    "Personal profile page, finding friends, joining groups, robust bookmarking, academic standards library, and featured products pages.",
  ],
  1: [
    "Sync your Google calendar.",
    "Use Holds to tell the AI and outside requesters when to drop-in appointments and meetings. A Hold has your label on bracketed open time which can also have minus-time breaks within it. Educators might use a label like “Parent Conference Time” from 3-4:00 pm Monday through Friday.",
    "Create interest groups.",
    "Create event groups.",
  ],
  2: [
    "Create one-teacher-school group and interest groups.",
    "Sync your Google calendar.",
    "Create Holds to bracket and label open time.",
    "Create interest and event groups.",
    "Frame your courses to be self-paced but live-intersecting on-demand by building descriptions per step and attaching auto-cohorting class meetings with any step.",
    "Display courses in the featured products section.",
    "Tracking panels.",
    "Create 'Awarded' Cred from your Group (Grades/Marks, Certificates.)",
    "Create a master calendar for your schedule.",
    "Assign study schedules to members.",
    "Use academic standards for all U.S. States and Canada in Course Frames.",
    "Use bookmarking for planning.",
  ],
  3: [
    "Claim or create school and districts groups.",
    "Sync Google or Outlook calendars for all users.",
    "Users create Holds to bracket and label open time.",
    "Create interest groups.",
    "Create event groups.",
    "Associate schools under districts for collective analytics.",
    "Authentication to invite learners.",
    "Frame your courses to be self-paced but live-intersecting on-demand by building descriptions per step and attaching auto-cohorting class meetings.",
    "Option for closed social feeds for members.",
    "Build course steps and attach auto-cohorting class meetings by step.",
    "Add academic standards, attachments, links and quizzes to steps.",
    "Display courses in the featured products section.",
    "Tracking panels.",
    "Create Validated Cred badges from your Group – Social, Extra-Curricular, Grades/Marks, Certificates, Degrees and Diplomas.",
    "Create a master calendar for your schedule.",
    "Assign study schedules to members.",
    "Use academic standards for all U.S. States and Canada in Course Frames.",
    "Use bookmarking for planning.",
    "Instant transfer of courses and associated class meetings to substitutes, tutors and new teachers.",
  ],
  4: [
    "Create your company group and interest groups.",
    "Authentication for offering demo scheduling to Learners (which may include parents), and educators.",
    "Sync Google calendars for all users.",
    "Associate a 'School' premium account under your company premium account to offer courses with live teaching or tutoring.",
    "Use Holds to tell the AI and outside requesters when to drop-in appointments and meetings. A Hold has your label on bracketed open time which can also have minus-time breaks within it. Your company agents might use a label like 'Demo Time' from 9-12:00pm Monday through Friday.",
    "Build product tiles in the featured products section of the site with full descriptions.",
    "Create interest groups.",
    "Create event groups.",
  ],
}
